import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  inputWrapper: {
    display: 'flex',
    width: '100%',
    position: 'relative',
  },

  posts: {
    width: '100%',
    marginTop: theme.spacing(1.2),
  },

}));

export default useStyles;
